import axios from "axios";

const API = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export const createDonation = (donationData) =>
  API.post("/donations", donationData);

export const updateDonationPayment = (donationId, paymentData) =>
  API.patch(`/donations/${donationId}/payment`, paymentData);

export default API;